module.exports = __webpack_public_path__ + "img/add-shipment.4a36d5a1.svg";